import { render } from 'preact';
import Menu from './menu/MenuApp';

const domElement = document.getElementById( 'menu-mountpoint' );

render( <Menu />, domElement );
